<div class="data">
  <div class="label">Базис</div>
  <div class="value" data-cy="basisCode">{{ data.basisCode }}</div>
  <div class="label shipment-time">Срок отгрузки</div>
  <div class="value" data-cy="shipmentTime">
    {{ data.shipmentTime || '—' }} {{ daysPlural(data.shipmentTime) }}
  </div>
  <div class="label delivery-time">Время в пути</div>
  <div class="value" data-cy="deliveryTime">
    {{ data.deliveryTime || '—' }} {{ daysPlural(data.deliveryTime) }}
  </div>
</div>
